import React from 'react'
import PropTypes from 'prop-types'
import {Table} from 'semantic-ui-react'
import css from './AccessKeyRow.scss'
import DeleteAccessKey from "./DeleteAccessKey";
import Switch from "../common/Switch";

/**
 * Represents a single row in the access keys table in the Data Extracts Tenant Admin page. This table
 * allows a tenant to configure credentials that can access the data extract data.
 *
 * @param {Object} props - see propTypes
 * @returns {JSX.Element} A single row of the access keys table in the tenant admin Data Extracts page
 */
const AccessKeyRow = (props) => {
   const formatUserType = (usertype) => {
       switch (usertype) {
           case "general_data_extracts":
               return "General Data Extracts"
           case "eab_edify":
               return "EAB Edify"
           case "eab_impact_analytics":
               return "EAB Impact Analytics"
       }
   }

    return (
        <Table.Row className={css['access-row']}>
            <Table.Cell>
                <div className={css['checkbox-container']}>
                    <div className={css["toggle"]}>
                        <Switch aria-labelledby={'access-key-status-' + props.access_key}
                                checked={props.access_key_status === "Active"}
                                onChange={() => {
                                    props.setIsOpenUpdateAccessKeyStatus(true)
                                    props.onAccessKeyStatusChange(props.user_name, props.access_key_status)
                                }}
                                data-testid={'access-key-status-' + props.access_key}/>
                        <label id={'access-key-status-' + props.access_key}></label>
                    </div>
                </div>
            </Table.Cell>
            <Table.Cell className={css['access_key']}>
                <span>{props.access_key}</span>
            </Table.Cell>
            <Table.Cell>
                <span>{props.access_key_created_date}</span>
            </Table.Cell>
            <Table.Cell>
                <span>{formatUserType(props.user_type)}</span>
            </Table.Cell>
            <Table.Cell>
                <DeleteAccessKey
                    userName={props.user_name}
                    setIsOpenDeleteAccessKey={props.setIsOpenDeleteAccessKey}
                    setDeleteUserName={props.setDeleteUserName}
                />
            </Table.Cell>
        </Table.Row>
    )
}

AccessKeyRow.propTypes = {
    access_key: PropTypes.string,
    access_key_created_date: PropTypes.string,
    access_key_status: PropTypes.string,
    user_type: PropTypes.string,
    user_name: PropTypes.string,
    setIsOpenDeleteAccessKey: PropTypes.func.isRequired,
    setDeleteUserName: PropTypes.func.isRequired,
    index: PropTypes.number,
    setIsOpenUpdateAccessKeyStatus: PropTypes.func.isRequired,
    onAccessKeyStatusChange: PropTypes.func.isRequired
}

export default AccessKeyRow
